import { buildAdminOAuthConfig } from './adminOAuth';

export type AdminLogoutConfig = {
  oauth2?: unknown;
  storage?: {
    tokenKey?: string;
    userKey?: string;
    refreshTokenKey?: string;
    idTokenKey?: string;
    tokenTypeKey?: string;
    tokenExpiresAtKey?: string;
  };
} | null | undefined;

type AdminStorageKeys = {
  tokenKey?: string;
  userKey?: string;
  refreshTokenKey?: string;
  idTokenKey?: string;
  tokenTypeKey?: string;
  tokenExpiresAtKey?: string;
};

export type AdminLogoutFn = (
  navigate: (path: string) => void,
  config?: unknown,
  storageKeys?: AdminStorageKeys,
) => Promise<void>;

export const restartAdminLogin = (
  navigate: (path: string, options?: { replace?: boolean; state?: unknown }) => void,
  config: AdminLogoutConfig,
  authServerUrl: string,
  logoutFn?: AdminLogoutFn,
): Promise<void> => {
  const logoutConfig = config || { oauth2: buildAdminOAuthConfig({ authServerUrl }) };
  const run = async () => {
    const resolvedLogoutFn = logoutFn ?? (await import('@edusense/shared-auth-core')).performWebLogout;
    return resolvedLogoutFn(
      (path: string) => {
        if (typeof window !== 'undefined') {
          window.location.assign(path);
          return;
        }
        navigate(path, { replace: true });
      },
      logoutConfig,
      config?.storage,
    );
  };

  return run();
};
